import { React, useState, useEffect } from 'react'
import { useLocation } from 'react-router'

import { lP, APPMODE } from '../../main.js'

import './MainHeader.css'
import './MMainHeader.css'
import '../../main.css'

import Cookies from 'universal-cookie'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faRightToBracket, faRightFromBracket, faUser, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'

import logo_mainbyton from '../../assets/pictures/logos/4Helferzeit-Logo2x.webp'
import m_logo_mainbyton from '../../assets/pictures/logos/1Helferzeit-Logo2x.webp'

const cookies = new Cookies()

export default function MainHeader(props) {

  var [cur_userid, setCur_userid] = useState("")
  var [cur_firstname, setCur_firstname] = useState("")
  var [cur_lastname, setCur_lastname] = useState("")
  var [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setCur_userid(cookies.get('userid'))
    setCur_firstname(cookies.get('firstname') || '')
    setCur_lastname(cookies.get('lastname') || '')
  }, [])

  useEffect(() => {
    setMenuOpen(false)
  }, [location.pathname])

  let loggedin = (cur_userid != "" && cur_userid != undefined)
  let initials = ''
  if (cur_firstname && cur_lastname) {
    initials = (cur_firstname.charAt(0) + cur_lastname.charAt(0)).toUpperCase()
  } else if (cur_firstname) {
    initials = cur_firstname.charAt(0).toUpperCase()
  }

  function isActive(path) {
    if (path === '/') return location.pathname === '/'
    return location.pathname.startsWith(path)
  }

  function doLogout() {
    const userCookies = Object.keys(cookies.getAll())
    userCookies.forEach((key) => cookies.remove(key))
    window.location.href = "/login"
  }

  return (
    <div className="site-header-wrapper">
      {/* <div className="banner-info">
        ℹ️ Einschränkungen bei der Zustellung von E-Mails.{' '}
        <a href="https://www.helferzeit.de/news/overview" target="_blank" rel="noopener noreferrer">
          Weitere Infos hier
        </a>
      </div> */}
      <div className="banner-info">
        ✨ Neues Design für die Helferzeit-App!{' '}
        <a href="https://www.helferzeit.de/news/overview" target="_blank" rel="noopener noreferrer">
          Weitere Infos
        </a>
      </div>

      {APPMODE === "pre" ? (
        <div className="dev-banner dev-banner--pre">VORABVERSION</div>
      ) : APPMODE !== "prod" ? (
        <div className="dev-banner">🛠️ ACHTUNG: ENTWICKLUNGSVERSION 🛠️</div>
      ) : null}

      <header className="site-header">
        <div className="header-inner">
          <a href="/" className="header-logo" aria-label="Helferzeit Startseite">
            <img src={logo_mainbyton} alt="Helferzeit Logo" className="header-logo-desktop" />
            <img src={m_logo_mainbyton} alt="Helferzeit Logo" className="header-logo-mobile" />
          </a>
          <span className="badge badge-brand header-webapp-badge" title="Du bist in der Helferzeit-App">App</span>

          <div className="header-spacer"></div>

          <a
            href="https://www.helferzeit.de"
            target="_blank"
            rel="noopener noreferrer"
            className="header-site-link"
          >
            helferzeit.de <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </a>

          {loggedin ? (
            <div className="user-chip" onClick={() => lP('/profil')} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter') lP('/profil') }} aria-label="Zum Profil">
              <div className="user-avatar">{initials || '?'}</div>
              <span>{cur_firstname} {cur_lastname}</span>
            </div>
          ) : (
            <a href="/login" className="btn btn-primary btn-sm header-login-btn">
              <FontAwesomeIcon icon={faRightToBracket} /> Anmelden
            </a>
          )}

          <button
            className={'burger' + (menuOpen ? ' open' : '')}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? "Menü schließen" : "Menü öffnen"}
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <nav className={'mobile-menu' + (menuOpen ? ' open' : '')} aria-label="Mobile Navigation">
          <a href="/"><FontAwesomeIcon icon={faHouse} />Start</a>
          {loggedin ? (
            <a href="/profil" className={isActive('/profil') ? 'active' : ''}>
              <FontAwesomeIcon icon={faUser} />Mein Profil
            </a>
          ) : null}
          <a href="https://www.helferzeit.de" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />helferzeit.de
          </a>
          <hr />
          {loggedin ? (
            <a href="#" onClick={(e) => { e.preventDefault(); doLogout() }}>
              <FontAwesomeIcon icon={faRightFromBracket} />Abmelden
            </a>
          ) : (
            <a href="/login"><FontAwesomeIcon icon={faRightToBracket} />Anmelden</a>
          )}
        </nav>
      </header>
    </div>
  )
}
